import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Button, DatePicker, Checkbox, Select, message, Row, Col, Typography, Divider } from "antd";
import { connect } from "react-redux";
import { updateInvoice, sendDispatchSms } from "../../../actions/invoiceItem";
import { getdeliverytype } from "../../../actions/settings";
import moment from "moment";

const { Option } = Select;

const UpdateDispatchDrawer = ({ visible, onClose, invoice, onReload, getdeliverytype, updateInvoice, sendDispatchSms, Auth }) => {
  const [form] = Form.useForm();
  const [deliveryTypes, setDeliveryTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getdeliverytype().then((res) => {
      if (res) {
        setDeliveryTypes(res);
      }
    });
  }, [getdeliverytype]);

  useEffect(() => {
    if (invoice && visible) {
      form.setFieldsValue({
        dispatch_date: invoice.dispatch_date ? moment(invoice.dispatch_date) : moment(),
        dispatch_order: invoice.dispatch_order || false,
        DeliveryType: invoice.DeliveryType && invoice.DeliveryType.id ? invoice.DeliveryType.id : invoice.DeliveryType,
        dispatched_by: invoice.dispatched_by || (Auth && Auth.profile && Auth.profile.name) || "",
        shipping_name: invoice.shipping_name || (invoice.contact && invoice.contact.name) || "",
        shipping_phone: invoice.shipping_phone || (invoice.contact && invoice.contact.phone) || "",
        shipping_address: invoice.shipping_address || (invoice.contact && invoice.contact.address) || "",
        remarks: invoice.remarks || "",
      });
    }
  }, [invoice, visible, form]);

  const handleSendSms = async () => {
    setLoading(true);
    let values = {
      dispatch_order: form.getFieldValue("dispatch_order"),
      DeliveryType: form.getFieldValue("DeliveryType"),
      dispatch_date: form.getFieldValue("dispatch_date"),
      dispatched_by: form.getFieldValue("dispatched_by"),   
    };

    if (values.dispatch_date) {
      values.dispatch_date = values.dispatch_date.format("YYYY-MM-DD");
    } else if (values.dispatch_order && values.DeliveryType) {
      values.dispatch_date = moment().format("YYYY-MM-DD");
    }

    const result = await sendDispatchSms(invoice.id, values);
    if (result) {
      onReload();
    }
    setLoading(false);
  };


  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        ...values,
        dispatch_date: values.dispatch_date ? values.dispatch_date.format("YYYY-MM-DD") : null,
      };
      
      await updateInvoice(invoice.id, payload);
      message.success("Dispatch details updated successfully!");
      onReload();
      onClose();
    } catch (error) {
      message.error("Failed to update dispatch details.");
    }
    setLoading(false);
  };

  return (
    <Drawer
      title={
        <Typography.Title level={4} style={{ margin: 0 }}>
          Update Dispatch Details - {(invoice && invoice.invoice_number) || ""}
        </Typography.Title>
      }
      width={720}
      onClose={onClose}
      visible={visible}
      bodyStyle={{ paddingBottom: 80, backgroundColor: "#f9f9f9" }}
    >
      <Form layout="vertical" form={form} onFinish={onFinish} style={{ backgroundColor: "#fff", padding: "24px", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item name="dispatch_order" valuePropName="checked">
              <Checkbox style={{ fontWeight: "bold", fontSize: "16px" }}>Dispatch Order</Checkbox>
            </Form.Item>
            <Divider style={{ marginTop: 0 }} />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item name="dispatch_date" label={<b>Dispatch Date</b>}>
              <DatePicker style={{ width: "100%" }} disabled />
            </Form.Item>
          </Col>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) => prevValues.dispatch_order !== currentValues.dispatch_order}
          >
            {({ getFieldValue }) =>
              getFieldValue('dispatch_order') === true ? (
                <>
                  <Col span={12}>
                    <Form.Item name="DeliveryType" label={<b>Delivery Method</b>}>
                      <Select placeholder="Select Delivery Method" allowClear>
                        {deliveryTypes.map((type) => (
                          <Option key={type.id} value={type.id}>
                            {type.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Row gutter={8} align="bottom">
                      <Col span={16}>
                        <Form.Item name="dispatched_by" label={<b>Dispatched By</b>} style={{ marginBottom: 0 }}>
                          <Input placeholder="Dispatched By" disabled />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Button 
                          type="primary" 
                          onClick={handleSendSms}
                          style={{ width: '100%' }}
                        >
                          Send SMS
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </>
              ) : null
            }
          </Form.Item>
        </Row>

        {/* <Row gutter={24}>
          <Col span={12}>
            <Form.Item name="shipping_phone" label={<b>Shipping Phone</b>}>
              <Input placeholder="Shipping Phone" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={24}>
            <Form.Item name="shipping_name" label={<b>Shipping Name</b>}>
              <Input placeholder="Shipping Name" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={24}>
            <Form.Item name="shipping_address" label={<b>Shipping Address</b>}>
              <Input.TextArea placeholder="Shipping Address" rows={3} style={{ borderRadius: "6px" }} />
            </Form.Item>
          </Col>
        </Row> */}
        
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item name="remarks" label={<b>Remarks</b>}>
              <Input.TextArea placeholder="Add remarks..." rows={2} style={{ borderRadius: "6px" }} />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item shouldUpdate>
          {({ getFieldValue }) => (
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading} 
              style={{ width: "100%" }}
              disabled={!getFieldValue('dispatch_order') || !getFieldValue('DeliveryType')}
            >
              Save Updates
            </Button>
          )}
        </Form.Item>
      </Form>
    </Drawer>
  );
};

const mapStateToProps = (state) => ({
  Auth: state.auth,
});

export default connect(mapStateToProps, { getdeliverytype, updateInvoice, sendDispatchSms })(UpdateDispatchDrawer);
